export default "__VITE_ASSET__28216366__"